import React, { ReactElement, FunctionComponent } from "react";
import { ResponsiveBar } from "@nivo/bar";
import { GraphProps } from "../../../wrappers/LoadingGraph";

const PartnersSendingAdsGraph: FunctionComponent<GraphProps> = ({
  records,
}: GraphProps): ReactElement => (
  <ResponsiveBar
    data={records}
    keys={["partner_count"]}
    indexBy="yearweek"
    animate={true}
    axisTop={null}
    axisRight={null}
    enableGridY={false}
    enableGridX={false}
    margin={{ top: 50, right: 20, bottom: 50, left: 60 }}
    axisBottom={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legendPosition: "middle",
      legendOffset: 40,
    }}
    axisLeft={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legendPosition: "middle",
      legendOffset: -40,
    }}
  />
);

export default PartnersSendingAdsGraph;
